import React, { useState, useEffect } from 'react'
import { motion } from 'framer-motion'

interface AnimatedVerseProps {
  verse: string
  reference: string
  className?: string
}

const AnimatedVerse: React.FC<AnimatedVerseProps> = ({ 
  verse, 
  reference, 
  className = "" 
}) => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 500)
    return () => clearTimeout(timer)
  }, [])

  return (
    <motion.div
      className={`bg-gradient-to-r from-slate-800/40 to-slate-900/40 backdrop-blur-sm border border-slate-700/50 rounded-xl p-4 md:p-8 relative ${className}`}
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      <motion.div
        className="text-sm sm:text-base md:text-lg leading-relaxed font-serif text-gray-100 mb-3 sm:mb-4 max-w-3xl mx-auto"
        initial={{ opacity: 0 }}
        animate={{ opacity: isVisible ? 1 : 0 }}
        transition={{ duration: 1, delay: 0.5 }}
      >
        "{verse}"
      </motion.div>
      
      <motion.div
        className="text-bible-gold text-xs sm:text-sm font-semibold text-center"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: isVisible ? 1 : 0, y: isVisible ? 0 : 10 }}
        transition={{ duration: 0.6, delay: 1 }}
      >
        {reference}
      </motion.div>

      {/* Decorative elements */}
      <motion.div
        className="absolute top-2 left-2 md:top-4 md:left-4 w-4 h-4 md:w-8 md:h-8 border-l-2 border-t-2 border-bible-gold/50"
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, delay: 1.2 }}
      />
      <motion.div
        className="absolute bottom-2 right-2 md:bottom-4 md:right-4 w-4 h-4 md:w-8 md:h-8 border-r-2 border-b-2 border-bible-gold/50"
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, delay: 1.4 }}
      />
    </motion.div>
  )
}

export default AnimatedVerse

